import { render } from "./PopUpWrapper.vue?vue&type=template&id=0178e61a"
import script from "./PopUpWrapper.vue?vue&type=script&lang=js"
export * from "./PopUpWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__